import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { BASEURL_POLYMER, SUB_PATH_BASIC } from "../../utils/api";
import { PaymentSuccessDetailsProps } from "../../pages/application-coo-stage-c/stage-c-success";
import { CancellationFeesDto } from "../../models/classes/stage-c/Process-Payment.class";
interface QueryParams {
  application_uuid: string;
  singpass_token: string;
}
export const paymentInfoApi = createApi({
  reducerPath: "paymentInfoApi",
  baseQuery: fetchBaseQuery({
    baseUrl: BASEURL_POLYMER,
    prepareHeaders: (headers, { getState }) => {
      headers.set("Access-Control-Request-Method", "GET");
      headers.set("X-Content-Type-Options", "nosniff");
    },
  }),
  endpoints: (builder) => ({
    getPaymentInfo: builder.query<PaymentSuccessDetailsProps, QueryParams>({
      query: (queryParams: QueryParams) => ({
        method: "GET",
        url: `${SUB_PATH_BASIC}/payment-info?applicationUuid=${queryParams.application_uuid}`,
        headers: {
          Authorization: `Bearer ${queryParams.singpass_token}`,
        },
      }),
      keepUnusedDataFor: 1,
    }),
    getCancellationFees: builder.query<CancellationFeesDto[], QueryParams>({
      query: (queryParams: QueryParams) => ({
        method: "GET",
        url: `${SUB_PATH_BASIC}/cancellation-fees?applicationUuid=${queryParams.application_uuid}`,
        headers: {
          Authorization: `Bearer ${queryParams.singpass_token}`,
        },
      }),
    }),
  }),
});

export const { useGetPaymentInfoQuery, useGetCancellationFeesQuery } = paymentInfoApi;
